// AUTO-GENERATED from public/ems/index.html by scripts/gen-ems.js — do not edit by hand.
// The EMS dashboard's original CSS/markup/logic, ported verbatim into a module.
// Only mechanical transforms were applied (see generator). Behavior is identical
// to the standalone HTML app; it runs inside a Shadow DOM for style isolation.
/* eslint-disable */
export const EMS_CSS = "\r\n*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}\r\n:host{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;font-size:13px;background:#F3F4F6;color:#111827;display:block;min-height:100vh;position:relative;}\r\n.page{max-width:1140px;margin:20px auto;background:#fff;border-radius:10px;border:1px solid #E5E7EB;overflow:hidden;}\r\n.topbar{display:flex;align-items:center;justify-content:space-between;padding:12px 22px;background:#1A2235;}\r\n.topbar-l{font-size:15px;font-weight:600;color:#fff;letter-spacing:-.01em;}\r\n.topbar-r{font-size:11px;color:#9CA3AF;}\r\n.nav{display:flex;background:#111827;border-bottom:1px solid #374151;}\r\n.ni{padding:10px 16px;font-size:12px;font-weight:500;color:#9CA3AF;cursor:pointer;user-select:none;border-bottom:2px solid transparent;transition:color .12s;white-space:nowrap;}\r\n.ni:hover{color:#D1D5DB;}\r\n.ni.active{color:#fff;border-bottom:2px solid #EF4444;}\r\n.ni.active.ops{border-bottom-color:#F59E0B;}\r\n.ni.active.dump{border-bottom-color:#6B7280;}\r\n.sec{display:none;}.sec.active{display:block;}\r\n.fb,.filterbar{display:flex;align-items:flex-start;gap:8px 12px;padding:10px 22px;border-bottom:1px solid #E5E7EB;flex-wrap:wrap;background:#FAFAFA;}\r\n.filter-group{display:inline-flex;align-items:center;gap:5px;min-height:28px;}\r\n.flbl{font-size:10px;font-weight:600;color:#9CA3AF;text-transform:uppercase;letter-spacing:.06em;margin-right:2px;white-space:nowrap;}\r\n.fp{padding:3px 10px;border-radius:20px;border:1px solid #E5E7EB;font-size:11px;color:#6B7280;cursor:pointer;user-select:none;background:#fff;transition:all .1s;}\r\n.fp:hover{border-color:#9CA3AF;color:#374151;}\r\n.fp.on{background:#1A2235;color:#fff;border-color:#1A2235;}\r\n.fp.on::after{content:' ✕';font-size:9px;opacity:.7;}\r\n.fsel-wrap{display:inline-flex;align-items:center;gap:6px;}\r\n.fsel{height:28px;min-width:210px;padding:0 28px 0 10px;border:1px solid #D1D5DB;border-radius:6px;background:#fff;color:#374151;font-size:11px;outline:none;}\r\n.fsel:focus{border-color:#9CA3AF;box-shadow:0 0 0 2px rgba(156,163,175,.15);}\r\n.filter-menu{position:relative;}\r\n.filter-trigger{height:28px;min-width:104px;max-width:220px;padding:0 28px 0 10px;border:1px solid #D1D5DB;border-radius:6px;background:#fff;color:#374151;font-size:11px;text-align:left;cursor:pointer;position:relative;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}\r\n.filter-trigger::after{content:'v';position:absolute;right:9px;top:50%;transform:translateY(-52%);font-size:10px;color:#9CA3AF;}\r\n.filter-trigger.on{background:#1A2235;color:#fff;border-color:#1A2235;}\r\n.filter-trigger.on::after{color:#D1D5DB;}\r\n.filter-menu.open .filter-trigger{border-color:#9CA3AF;box-shadow:0 0 0 2px rgba(156,163,175,.15);}\r\n.filter-panel{display:none;position:absolute;top:32px;left:0;z-index:50;min-width:210px;max-width:280px;max-height:260px;overflow:auto;padding:6px;background:#fff;border:1px solid #D1D5DB;border-radius:8px;box-shadow:0 12px 28px rgba(17,24,39,.14);}\r\n.filter-menu.open .filter-panel{display:block;}\r\n.filter-option{display:flex;align-items:center;gap:8px;width:100%;padding:7px 8px;border-radius:6px;font-size:11px;color:#374151;cursor:pointer;line-height:1.2;}\r\n.filter-option:hover{background:#F3F4F6;}\r\n.filter-option{border:none;background:none;text-align:left;}\r\n.filter-option input{width:13px;height:13px;accent-color:#1A2235;flex:0 0 auto;}\r\n.client-search{width:100%;height:28px;margin-bottom:6px;padding:0 9px;border:1px solid #D1D5DB;border-radius:6px;font-size:11px;color:#374151;outline:none;}\r\n.client-search:focus{border-color:#9CA3AF;box-shadow:0 0 0 2px rgba(156,163,175,.15);}\r\n.client-option.on{background:#1A2235;color:#fff;}\r\n.filter-empty{padding:8px;color:#9CA3AF;font-size:11px;}\r\n.kpi-strip{display:flex;border-bottom:1px solid #E5E7EB;}\r\n.kpi{flex:1;padding:16px 18px;border-right:1px solid #E5E7EB;}\r\n.kpi:last-child{border-right:none;}\r\n.kpi-lbl{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#9CA3AF;margin-bottom:5px;}\r\n.kpi-big{font-size:32px;font-weight:600;line-height:1;}\r\n.kpi-big.r{color:#991B1B;}.kpi-big.a{color:#92400E;}.kpi-big.g{color:#166534;}\r\n.kpi-small{font-size:11px;color:#6B7280;margin-top:4px;}\r\n.tbl-wrap{overflow-x:auto;}\r\ntable{width:100%;border-collapse:collapse;}\r\nth{font-size:10px;font-weight:600;color:#6B7280;padding:8px 14px;text-align:left;border-bottom:1px solid #E5E7EB;background:#FAFAFA;white-space:nowrap;cursor:pointer;user-select:none;}\r\nth:hover{background:#F3F4F6;}\r\ntd{padding:9px 14px;border-bottom:1px solid #F3F4F6;vertical-align:middle;}\r\ntr:last-child td{border-bottom:none;}\r\ntr:hover td{background:#FAFAFA;}\r\n.fw6{font-weight:600;}.muted{color:#6B7280;font-size:11px;}\r\n.no-rows{padding:28px;text-align:center;color:#9CA3AF;font-size:12px;}\r\n.dot{display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:4px;vertical-align:middle;}\r\n.d-r{background:#EF4444;}.d-a{background:#F59E0B;}.d-g{background:#9CA3AF;}\r\n.pill{display:inline-flex;padding:2px 7px;border-radius:3px;font-size:10px;font-weight:600;white-space:nowrap;}\r\n.p-r{background:#FEE2E2;color:#991B1B;}.p-a{background:#FEF3C7;color:#92400E;}\r\n.p-g{background:#F3F4F6;color:#374151;}.p-gr{background:#D1FAE5;color:#065F46;}\r\n.p-b{background:#DBEAFE;color:#1E40AF;}.p-p{background:#EDE9FE;color:#4C1D95;}\r\n.p-o{background:#FFEDD5;color:#9A3412;}.p-res{background:#D1FAE5;color:#065F46;}\r\n.ava{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;font-size:9px;font-weight:700;margin-right:4px;}\r\n.av-N{background:#FEF3C7;color:#92400E;}.av-P{background:#DBEAFE;color:#1E40AF;}\r\n.av-S{background:#D1FAE5;color:#065F46;}.av-V{background:#EDE9FE;color:#4C1D95;}\r\n.av-D{background:#F3F4F6;color:#6B7280;}\r\n.age-r{color:#991B1B;font-weight:600;}.age-t{color:#9CA3AF;font-style:italic;}\r\n/* Analysis */\r\n.analysis-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;padding:16px 22px;}\r\n.acard{border:1px solid #E5E7EB;border-radius:8px;overflow:hidden;}\r\n.acard.full{grid-column:1/-1;}\r\n.ahead{padding:10px 14px;background:#FAFAFA;border-bottom:1px solid #E5E7EB;}\r\n.atitle{font-size:12px;font-weight:600;color:#111827;}\r\n.asub{font-size:10px;color:#9CA3AF;margin-top:1px;}\r\n.abody{padding:12px 14px;}\r\n.hmap-wrap{width:100%;overflow-x:auto;padding-bottom:4px;}\r\n.hmap{width:max-content;min-width:100%;border-collapse:collapse;font-size:11px;}\r\n.hmap th{font-size:10px;font-weight:600;color:#6B7280;padding:5px 8px;text-align:center;border-bottom:1px solid #E5E7EB;background:#FAFAFA;min-width:92px;}\r\n.hmap th:first-child{text-align:left;}\r\n.hmap td{padding:7px 8px;text-align:center;border-bottom:1px solid #F3F4F6;}\r\n.hmap td:first-child{text-align:left;font-weight:600;color:#111827;position:sticky;left:0;background:#fff;z-index:1;min-width:96px;}\r\n.hmap tr:last-child td{border-bottom:none;}\r\n.hcell{display:inline-grid;grid-template-columns:1fr 1fr;align-items:stretch;width:58px;height:24px;border-radius:4px;overflow:hidden;font-size:10px;font-weight:700;border:1px solid #E5E7EB;background:#F3F4F6;color:#9CA3AF;}\r\n.hcell-empty{display:inline-flex;align-items:center;justify-content:center;width:58px;height:24px;border-radius:4px;background:#F3F4F6;color:#D1D5DB;font-size:11px;font-weight:700;border:1px solid #E5E7EB;}\r\n.hseg{display:flex;align-items:center;justify-content:center;min-width:0;}\r\n.hseg-r{background:#EF4444;color:#fff;}\r\n.hseg-y{background:#FEF3C7;color:#92400E;}\r\n.hseg-zero{background:#F9FAFB;color:#D1D5DB;}\r\n.cc-row{display:flex;align-items:center;justify-content:space-between;padding:8px 0;border-bottom:1px solid #F3F4F6;font-size:12px;}\r\n.cc-row:last-child{border-bottom:none;}\r\n.cc-name{font-weight:600;}.cc-meta{font-size:11px;color:#6B7280;margin-top:1px;}\r\n.lp-row{display:flex;align-items:center;gap:10px;padding:7px 0;border-bottom:1px solid #F3F4F6;font-size:12px;}\r\n.lp-row:last-child{border-bottom:none;}\r\n.lp-days{min-width:32px;font-size:15px;font-weight:600;color:#991B1B;}\r\n.lp-client{font-weight:600;}.lp-detail{font-size:11px;color:#6B7280;margin-top:1px;}\r\n.empty-s{padding:20px;text-align:center;color:#9CA3AF;font-size:12px;}\r\n.legend-row{display:flex;gap:10px;flex-wrap:wrap;margin-top:10px;}\r\n.li{display:flex;align-items:center;gap:4px;font-size:10px;color:#6B7280;}\r\n.ld{width:12px;height:12px;border-radius:2px;}\r\n.footer{padding:10px 22px;font-size:10px;color:#9CA3AF;text-align:center;border-top:1px solid #E5E7EB;}\r\n/* Loading overlay */\r\n#ems-loading,#ems-err{position:absolute;inset:0;background:rgba(17,24,39,.65);display:flex;align-items:center;justify-content:center;z-index:999;}\r\n#ems-err{display:none;}\r\n.ld-inner{background:#fff;border-radius:10px;padding:32px 44px;text-align:center;display:flex;flex-direction:column;align-items:center;gap:14px;box-shadow:0 4px 24px rgba(0,0,0,.18);}\r\n.ld-txt{font-size:13px;color:#374151;font-weight:500;}\r\n.err-txt{color:#991B1B;}\r\n.ld-spinner{width:28px;height:28px;border:3px solid #E5E7EB;border-top-color:#1A2235;border-radius:50%;animation:spin .7s linear infinite;}\r\n@keyframes spin{to{transform:rotate(360deg);}}\r\n.retry-btn{padding:6px 18px;background:#1A2235;color:#fff;border:none;border-radius:6px;font-size:12px;cursor:pointer;font-weight:500;}\r\n.retry-btn:hover{background:#111827;}\r\n/* Resolved section */\r\n.resolved-section{border-top:2px solid #D1FAE5;}\r\n.res-toggle{display:flex;align-items:center;gap:8px;padding:10px 22px;cursor:pointer;background:#F0FDF4;font-size:12px;font-weight:500;color:#065F46;user-select:none;transition:background .1s;}\r\n.res-toggle:hover{background:#DCFCE7;}\r\n.res-arr{font-size:10px;transition:transform .18s;display:inline-block;}\r\n.res-count{color:#6B7280;font-weight:400;margin-left:2px;}\r\n.res-body{display:none;}\r\n.res-body table th{background:#F0FDF4;}\r\n";

export const EMS_HTML = "\r\n<div class=\"page\">\r\n\r\n<div class=\"topbar\">\r\n  <span class=\"topbar-l\">ARPFlow — EMS Dashboard</span>\r\n  <span class=\"topbar-r\"><span class=\"ems-date\">Loading…</span> · Internal use only</span>\r\n</div>\r\n\r\n<div class=\"nav\">\r\n  <div class=\"ni active\"    onclick=\"showSec('s1',this)\">Red Flags — Overview</div>\r\n  <div class=\"ni\"           onclick=\"showSec('s2',this)\">Red Flags — Analysis</div>\r\n  <div class=\"ni ops\"       onclick=\"showSec('s3',this)\">Ops Errors — Overview</div>\r\n  <div class=\"ni ops\"       onclick=\"showSec('s4',this)\">Ops Errors — Analysis</div>\r\n  <div class=\"ni dump\"      onclick=\"showSec('s5',this)\">All Errors</div>\r\n  <div class=\"ni\"           onclick=\"showSec('s6',this)\" style=\"border-left:2px solid #E5E7EB;margin-left:6px;padding-left:14px;\">GRN Issues</div>\r\n  <div class=\"ni\"           onclick=\"showSec('s8',this)\" style=\"border-left:2px solid #E5E7EB;margin-left:6px;padding-left:14px;\">Cred Verification</div>\r\n  <div class=\"ni\"           onclick=\"showSec('s9',this)\">Unmapped Vendors</div>\r\n  <!-- <div class=\"ni\"           onclick=\"showSec('s7',this)\">Payment Overdue</div> -->\r\n</div>\r\n\r\n<!-- ══ S1: RF OVERVIEW ══ -->\r\n<div id=\"s1\" class=\"sec active\">\r\n  <div class=\"fb filterbar\" id=\"fb1\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Severity:</span>\r\n      <span class=\"fp on\" data-f=\"all\" onclick=\"setF(1,'all',this)\">All</span>\r\n      <span class=\"fp\" data-f=\"red\" onclick=\"setF(1,'red',this)\">Red</span>\r\n      <span class=\"fp\" data-f=\"yellow\" onclick=\"setF(1,'yellow',this)\">Yellow</span>\r\n    </div>\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Activation:</span>\r\n      <span class=\"fp\" data-f=\"activation_all\" onclick=\"setActivationFilter(1,'activation_all')\">All</span>\r\n      <span class=\"fp\" data-f=\"activation_trial\" onclick=\"setActivationFilter(1,'activation_trial')\">Trial</span>\r\n      <span class=\"fp\" data-f=\"activation_active\" onclick=\"setActivationFilter(1,'activation_active')\">Active</span>\r\n    </div>\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-1-client\" onclick=\"toggleFilterMenu(1,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-1-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-1-kam\" onclick=\"toggleFilterMenu(1,'kam',event)\">Owner</button>\r\n      <div class=\"filter-panel\" id=\"fp-1-kam\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-1-platform\" onclick=\"toggleFilterMenu(1,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-1-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"error\">\r\n      <button class=\"filter-trigger\" id=\"fm-1-error\" onclick=\"toggleFilterMenu(1,'error',event)\">Error</button>\r\n      <div class=\"filter-panel\" id=\"fp-1-error\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"kpi-strip\">\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Red errors</div><div class=\"kpi-big r\" id=\"k1-rn\">–</div><div class=\"kpi-small\" id=\"k1-rc\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Yellow errors</div><div class=\"kpi-big a\" id=\"k1-yn\">–</div><div class=\"kpi-small\" id=\"k1-yc\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">New / unclassified</div><div class=\"kpi-big\" id=\"k1-un\">–</div><div class=\"kpi-small\" id=\"k1-uc\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Resolved</div><div class=\"kpi-big g\" id=\"k1-gn\">–</div><div class=\"kpi-small\" id=\"k1-gc\">– clients</div></div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th onclick=\"srt(1,'sev')\">Severity ↕</th>\r\n      <th onclick=\"srt(1,'client')\">Client ↕</th>\r\n      <th onclick=\"srt(1,'platform')\">Platform ↕</th>\r\n      <th onclick=\"srt(1,'error_label')\">Error ↕</th>\r\n      <th onclick=\"srt(1,'days')\">Days open ↕</th>\r\n      <th onclick=\"srt(1,'kam')\">KAM ↕</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb1\"></tbody>\r\n  </table></div>\r\n  <div class=\"resolved-section\">\r\n    <div class=\"res-toggle\" onclick=\"toggleRes(1)\">\r\n      <span class=\"res-arr\" id=\"res-arr-1\">▶</span>\r\n      <span>Resolved</span>\r\n      <span class=\"res-count\" id=\"res-cnt-1\"></span>\r\n    </div>\r\n    <div class=\"res-body\" id=\"res-body-1\">\r\n      <div class=\"tbl-wrap\"><table id=\"res-tbl-1\"></table></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- ══ S2: RF ANALYSIS ══ -->\r\n<div id=\"s2\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb2\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Severity:</span>\r\n      <span class=\"fp on\" data-f=\"all\" onclick=\"setF(2,'all',this)\">All</span>\r\n    </div>\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Activation:</span>\r\n      <span class=\"fp\" data-f=\"activation_all\" onclick=\"setActivationFilter(2,'activation_all')\">All</span>\r\n      <span class=\"fp\" data-f=\"activation_trial\" onclick=\"setActivationFilter(2,'activation_trial')\">Trial</span>\r\n      <span class=\"fp\" data-f=\"activation_active\" onclick=\"setActivationFilter(2,'activation_active')\">Active</span>\r\n    </div>\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-2-client\" onclick=\"toggleFilterMenu(2,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-2-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-2-kam\" onclick=\"toggleFilterMenu(2,'kam',event)\">Owner</button>\r\n      <div class=\"filter-panel\" id=\"fp-2-kam\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-2-platform\" onclick=\"toggleFilterMenu(2,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-2-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"error\">\r\n      <button class=\"filter-trigger\" id=\"fm-2-error\" onclick=\"toggleFilterMenu(2,'error',event)\">Error</button>\r\n      <div class=\"filter-panel\" id=\"fp-2-error\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"analysis-grid\">\r\n    <div class=\"acard\">\r\n      <div class=\"ahead\"><div class=\"atitle\">Critical portals</div><div class=\"asub\">Red and yellow red flag errors — portal × error type</div></div>\r\n      <div class=\"abody\"><div id=\"a-rf-hmap\"></div><div class=\"legend-row\">\r\n        <span class=\"li\"><span class=\"ld\" style=\"background:#EF4444;\"></span>Red count</span>\r\n        <span class=\"li\"><span class=\"ld\" style=\"background:#FEF3C7;border:1px solid #FDE68A;\"></span>Yellow count</span>\r\n        <span class=\"li\"><span class=\"ld\" style=\"background:#F3F4F6;border:1px solid #E5E7EB;\"></span>No errors</span>\r\n      </div></div>\r\n    </div>\r\n    <div class=\"acard\">\r\n      <div class=\"ahead\"><div class=\"atitle\">Critical clients</div><div class=\"asub\">Clients with 3 or more red/yellow red flag errors</div></div>\r\n      <div class=\"abody\" id=\"a-rf-cc\"></div>\r\n    </div>\r\n    <div class=\"acard full\">\r\n      <div class=\"ahead\"><div class=\"atitle\">Long persisting errors</div><div class=\"asub\">Red/yellow red flag errors open for more than 7 days</div></div>\r\n      <div class=\"abody\" id=\"a-rf-lp\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- ══ S3: OPS OVERVIEW ══ -->\r\n<div id=\"s3\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb3\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Severity:</span>\r\n      <span class=\"fp on\" data-f=\"all\" onclick=\"setF(3,'all',this)\">All</span>\r\n      <span class=\"fp\" data-f=\"red\" onclick=\"setF(3,'red',this)\">Red</span>\r\n      <span class=\"fp\" data-f=\"yellow\" onclick=\"setF(3,'yellow',this)\">Yellow</span>\r\n    </div>\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Activation:</span>\r\n      <span class=\"fp\" data-f=\"activation_all\" onclick=\"setActivationFilter(3,'activation_all')\">All</span>\r\n      <span class=\"fp\" data-f=\"activation_trial\" onclick=\"setActivationFilter(3,'activation_trial')\">Trial</span>\r\n      <span class=\"fp\" data-f=\"activation_active\" onclick=\"setActivationFilter(3,'activation_active')\">Active</span>\r\n    </div>\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-3-client\" onclick=\"toggleFilterMenu(3,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-3-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-3-kam\" onclick=\"toggleFilterMenu(3,'kam',event)\">Owner</button>\r\n      <div class=\"filter-panel\" id=\"fp-3-kam\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-3-platform\" onclick=\"toggleFilterMenu(3,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-3-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"error\">\r\n      <button class=\"filter-trigger\" id=\"fm-3-error\" onclick=\"toggleFilterMenu(3,'error',event)\">Error</button>\r\n      <div class=\"filter-panel\" id=\"fp-3-error\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"kpi-strip\">\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Red errors</div><div class=\"kpi-big r\" id=\"k3-rn\">–</div><div class=\"kpi-small\" id=\"k3-rc\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Yellow errors</div><div class=\"kpi-big a\" id=\"k3-yn\">–</div><div class=\"kpi-small\" id=\"k3-yc\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Error types</div><div class=\"kpi-big\">3</div><div class=\"kpi-small\">No-GRN · Stale GRN · Stale E-Invoice</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Resolved</div><div class=\"kpi-big g\" id=\"k3-gn\">–</div><div class=\"kpi-small\" id=\"k3-gc\">– clients</div></div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th onclick=\"srt(3,'sev')\">Severity ↕</th>\r\n      <th onclick=\"srt(3,'client')\">Client ↕</th>\r\n      <th onclick=\"srt(3,'platform')\">Platform ↕</th>\r\n      <th onclick=\"srt(3,'error_label')\">Error ↕</th>\r\n      <th onclick=\"srt(3,'days')\">Days open ↕</th>\r\n      <th onclick=\"srt(3,'kam')\">KAM ↕</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb3\"></tbody>\r\n  </table></div>\r\n  <div class=\"resolved-section\">\r\n    <div class=\"res-toggle\" onclick=\"toggleRes(3)\">\r\n      <span class=\"res-arr\" id=\"res-arr-3\">▶</span>\r\n      <span>Resolved</span>\r\n      <span class=\"res-count\" id=\"res-cnt-3\"></span>\r\n    </div>\r\n    <div class=\"res-body\" id=\"res-body-3\">\r\n      <div class=\"tbl-wrap\"><table id=\"res-tbl-3\"></table></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- ══ S4: OPS ANALYSIS ══ -->\r\n<div id=\"s4\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb4\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Severity:</span>\r\n      <span class=\"fp on\" data-f=\"all\" onclick=\"setF(4,'all',this)\">All</span>\r\n    </div>\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Activation:</span>\r\n      <span class=\"fp\" data-f=\"activation_all\" onclick=\"setActivationFilter(4,'activation_all')\">All</span>\r\n      <span class=\"fp\" data-f=\"activation_trial\" onclick=\"setActivationFilter(4,'activation_trial')\">Trial</span>\r\n      <span class=\"fp\" data-f=\"activation_active\" onclick=\"setActivationFilter(4,'activation_active')\">Active</span>\r\n    </div>\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-4-client\" onclick=\"toggleFilterMenu(4,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-4-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-4-kam\" onclick=\"toggleFilterMenu(4,'kam',event)\">Owner</button>\r\n      <div class=\"filter-panel\" id=\"fp-4-kam\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-4-platform\" onclick=\"toggleFilterMenu(4,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-4-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"error\">\r\n      <button class=\"filter-trigger\" id=\"fm-4-error\" onclick=\"toggleFilterMenu(4,'error',event)\">Error</button>\r\n      <div class=\"filter-panel\" id=\"fp-4-error\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"analysis-grid\">\r\n    <div class=\"acard\">\r\n      <div class=\"ahead\"><div class=\"atitle\">Ops errors by portal</div><div class=\"asub\">Red and yellow operational errors — portal × error type</div></div>\r\n      <div class=\"abody\"><div id=\"a-ops-hmap\"></div><div class=\"legend-row\">\r\n        <span class=\"li\"><span class=\"ld\" style=\"background:#EF4444;\"></span>Red count</span>\r\n        <span class=\"li\"><span class=\"ld\" style=\"background:#FEF3C7;border:1px solid #FDE68A;\"></span>Yellow count</span>\r\n        <span class=\"li\"><span class=\"ld\" style=\"background:#F3F4F6;border:1px solid #E5E7EB;\"></span>No errors</span>\r\n      </div></div>\r\n    </div>\r\n    <div class=\"acard\">\r\n      <div class=\"ahead\"><div class=\"atitle\">Most impacted clients</div><div class=\"asub\">Clients with 3 or more red/yellow operational errors</div></div>\r\n      <div class=\"abody\" id=\"a-ops-cc\"></div>\r\n    </div>\r\n    <div class=\"acard full\">\r\n      <div class=\"ahead\"><div class=\"atitle\">Long persisting operational errors</div><div class=\"asub\">Red/yellow ops errors open for more than 5 days</div></div>\r\n      <div class=\"abody\" id=\"a-ops-lp\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- ══ S5: ALL ERRORS ══ -->\r\n<div id=\"s5\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb5\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Severity:</span>\r\n      <span class=\"fp on\" data-f=\"all\" onclick=\"setF(5,'all',this)\">All</span>\r\n      <span class=\"fp\" data-f=\"red\" onclick=\"setF(5,'red',this)\">Severe</span>\r\n      <span class=\"fp\" data-f=\"yellow\" onclick=\"setF(5,'yellow',this)\">Warn</span>\r\n    </div>\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Type:</span>\r\n      <span class=\"fp\" data-f=\"Red Flag\" onclick=\"setF(5,'Red Flag',this)\">Red Flags</span>\r\n      <span class=\"fp\" data-f=\"Operational Error\" onclick=\"setF(5,'Operational Error',this)\">Ops Errors</span>\r\n    </div>\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Activation:</span>\r\n      <span class=\"fp\" data-f=\"activation_all\" onclick=\"setActivationFilter(5,'activation_all')\">All</span>\r\n      <span class=\"fp\" data-f=\"activation_trial\" onclick=\"setActivationFilter(5,'activation_trial')\">Trial</span>\r\n      <span class=\"fp\" data-f=\"activation_active\" onclick=\"setActivationFilter(5,'activation_active')\">Active</span>\r\n    </div>\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-5-client\" onclick=\"toggleFilterMenu(5,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-5-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-5-kam\" onclick=\"toggleFilterMenu(5,'kam',event)\">Owner</button>\r\n      <div class=\"filter-panel\" id=\"fp-5-kam\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-5-platform\" onclick=\"toggleFilterMenu(5,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-5-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"error\">\r\n      <button class=\"filter-trigger\" id=\"fm-5-error\" onclick=\"toggleFilterMenu(5,'error',event)\">Error</button>\r\n      <div class=\"filter-panel\" id=\"fp-5-error\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th onclick=\"srt(5,'category')\">Category ↕</th>\r\n      <th onclick=\"srt(5,'sev')\">Severity ↕</th>\r\n      <th onclick=\"srt(5,'client')\">Client ↕</th>\r\n      <th onclick=\"srt(5,'platform')\">Platform ↕</th>\r\n      <th onclick=\"srt(5,'error_label')\">Error ↕</th>\r\n      <th onclick=\"srt(5,'days')\">Days open ↕</th>\r\n      <th onclick=\"srt(5,'kam')\">KAM ↕</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb5\"></tbody>\r\n  </table></div>\r\n  <div class=\"resolved-section\">\r\n    <div class=\"res-toggle\" onclick=\"toggleRes(5)\">\r\n      <span class=\"res-arr\" id=\"res-arr-5\">▶</span>\r\n      <span>Resolved</span>\r\n      <span class=\"res-count\" id=\"res-cnt-5\"></span>\r\n    </div>\r\n    <div class=\"res-body\" id=\"res-body-5\">\r\n      <div class=\"tbl-wrap\"><table id=\"res-tbl-5\"></table></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- ══ S6: GRN ISSUES ══ -->\r\n<div id=\"s6\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb6\" style=\"flex-wrap:wrap;gap:8px;\">\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-6-client\" onclick=\"toggleTktMenu(6,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-6-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"clientid\">\r\n      <button class=\"filter-trigger\" id=\"fm-6-clientid\" onclick=\"toggleTktMenu(6,'clientid',event)\">Client ID</button>\r\n      <div class=\"filter-panel\" id=\"fp-6-clientid\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"issuetype\">\r\n      <button class=\"filter-trigger\" id=\"fm-6-issuetype\" onclick=\"toggleTktMenu(6,'issuetype',event)\">Issue Type</button>\r\n      <div class=\"filter-panel\" id=\"fp-6-issuetype\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"status\">\r\n      <button class=\"filter-trigger\" id=\"fm-6-status\" onclick=\"toggleTktMenu(6,'status',event)\">Status</button>\r\n      <div class=\"filter-panel\" id=\"fp-6-status\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-6-platform\" onclick=\"toggleTktMenu(6,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-6-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-6-kam\" onclick=\"toggleTktMenu(6,'kam',event)\">KAM</button>\r\n      <div class=\"filter-panel\" id=\"fp-6-kam\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platformticket\">\r\n      <button class=\"filter-trigger\" id=\"fm-6-platformticket\" onclick=\"toggleTktMenu(6,'platformticket',event)\">Ticket #</button>\r\n      <div class=\"filter-panel\" id=\"fp-6-platformticket\">\r\n        <label class=\"filter-option\"><input type=\"radio\" name=\"ptkt6\" value=\"\" checked onchange=\"setTktPlatformTicket(6,'')\"><span>All</span></label>\r\n        <label class=\"filter-option\"><input type=\"radio\" name=\"ptkt6\" value=\"has\" onchange=\"setTktPlatformTicket(6,'has')\"><span>Has Ticket #</span></label>\r\n        <label class=\"filter-option\"><input type=\"radio\" name=\"ptkt6\" value=\"missing\" onchange=\"setTktPlatformTicket(6,'missing')\"><span>No Ticket #</span></label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"kpi-strip\">\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Total Tickets</div><div class=\"kpi-big\" id=\"k6-total\">–</div><div class=\"kpi-small\" id=\"k6-clients\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">In Dispute</div><div class=\"kpi-big r\" id=\"k6-dispute\">–</div><div class=\"kpi-small\" id=\"k6-dispute-c\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Dispute · No Ticket #</div><div class=\"kpi-big r\" id=\"k6-dispute-no-tkt\">–</div><div class=\"kpi-small\" id=\"k6-dispute-no-tkt-c\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Pending Verification</div><div class=\"kpi-big a\" id=\"k6-pending\">–</div><div class=\"kpi-small\" id=\"k6-pending-c\">– clients</div></div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th onclick=\"tktSrt(6,'client_name')\">Client ↕</th>\r\n      <th onclick=\"tktSrt(6,'client_id')\">Client ID ↕</th>\r\n      <th onclick=\"tktSrt(6,'activation_status')\">Activation ↕</th>\r\n      <th onclick=\"tktSrt(6,'platform')\">Platform ↕</th>\r\n      <th>Invoice #</th>\r\n      <th onclick=\"tktSrt(6,'invoice_date')\">Date ↕</th>\r\n      <th>Platform Ticket #</th>\r\n      <th onclick=\"tktSrt(6,'issue_type')\">Issue Type ↕</th>\r\n      <th onclick=\"tktSrt(6,'status')\">Status ↕</th>\r\n      <th onclick=\"tktSrt(6,'invoice_amount')\">Amount ↕</th>\r\n      <th onclick=\"tktSrt(6,'ageing_days')\">Ageing ↕</th>\r\n      <th onclick=\"tktSrt(6,'kam')\">KAM ↕</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb6\"></tbody>\r\n  </table></div>\r\n</div>\r\n\r\n<!-- ══ S9: UNMAPPED VENDORS (SHARed LOGIN) ══ -->\r\n<div id=\"s9\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb9\" style=\"flex-wrap:wrap;gap:8px 12px;align-items:center;\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Platform:</span>\r\n      <select id=\"ven-platform\" class=\"client-search\" style=\"width:auto;min-width:130px;margin-bottom:0;\" onchange=\"refreshVendors()\">\r\n        <option value=\"\">All platforms</option>\r\n      </select>\r\n    </div>\r\n    <div class=\"filter-group\" style=\"flex:1;min-width:200px;\">\r\n      <input id=\"ven-search\" class=\"client-search\" style=\"margin-bottom:0;\" type=\"search\" placeholder=\"Search vendor or client…\" oninput=\"refreshVendors()\">\r\n    </div>\r\n  </div>\r\n  <div class=\"kpi-strip\">\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Unmapped vendors</div><div class=\"kpi-big r\" id=\"k9-current\">–</div><div class=\"kpi-small\" id=\"k9-current-p\">– platforms</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Recently mapped</div><div class=\"kpi-big g\" id=\"k9-resolved\">–</div><div class=\"kpi-small\" id=\"k9-resolved-c\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Oldest unmapped</div><div class=\"kpi-big\" id=\"k9-oldest\">–</div><div class=\"kpi-small\">days open</div></div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th onclick=\"venSrt('vendor_name')\">Vendor ↕</th>\r\n      <th onclick=\"venSrt('platform')\">Platform ↕</th>\r\n      <th onclick=\"venSrt('first_occurred_at')\">First seen ↕</th>\r\n      <th onclick=\"venSrt('days')\">Days open ↕</th>\r\n      <th onclick=\"venSrt('trigger_count')\">Occurrences ↕</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb9\"></tbody>\r\n  </table></div>\r\n  <div class=\"resolved-section\">\r\n    <div class=\"res-toggle\" onclick=\"toggleRes(9)\">\r\n      <span class=\"res-arr\" id=\"res-arr-9\">▶</span>\r\n      <span>Resolved — mapped to client</span>\r\n      <span class=\"res-count\" id=\"res-cnt-9\"></span>\r\n    </div>\r\n    <div class=\"res-body\" id=\"res-body-9\">\r\n      <div class=\"tbl-wrap\"><table id=\"res-tbl-9\"></table></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- ══ S7: PAYMENT OVERDUE (commented out) ══\r\n<div id=\"s7\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb7\" style=\"flex-wrap:wrap;gap:8px;\">\r\n    <div class=\"filter-group filter-menu client-menu\" data-menu-group=\"client\">\r\n      <span class=\"flbl\">Client:</span>\r\n      <button class=\"filter-trigger\" id=\"fm-7-client\" onclick=\"toggleTktMenu(7,'client',event)\">All clients</button>\r\n      <div class=\"filter-panel client-panel\" id=\"fp-7-client\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"clientid\">\r\n      <button class=\"filter-trigger\" id=\"fm-7-clientid\" onclick=\"toggleTktMenu(7,'clientid',event)\">Client ID</button>\r\n      <div class=\"filter-panel\" id=\"fp-7-clientid\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"status\">\r\n      <button class=\"filter-trigger\" id=\"fm-7-status\" onclick=\"toggleTktMenu(7,'status',event)\">Status</button>\r\n      <div class=\"filter-panel\" id=\"fp-7-status\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"platform\">\r\n      <button class=\"filter-trigger\" id=\"fm-7-platform\" onclick=\"toggleTktMenu(7,'platform',event)\">Platform</button>\r\n      <div class=\"filter-panel\" id=\"fp-7-platform\"></div>\r\n    </div>\r\n    <div class=\"filter-group filter-menu\" data-menu-group=\"kam\">\r\n      <button class=\"filter-trigger\" id=\"fm-7-kam\" onclick=\"toggleTktMenu(7,'kam',event)\">KAM</button>\r\n      <div class=\"filter-panel\" id=\"fp-7-kam\"></div>\r\n    </div>\r\n  </div>\r\n  <div class=\"kpi-strip\">\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Total Tickets</div><div class=\"kpi-big\" id=\"k7-total\">–</div><div class=\"kpi-small\" id=\"k7-clients\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Avg Ageing</div><div class=\"kpi-big\" id=\"k7-age\">–</div><div class=\"kpi-small\">days</div></div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th onclick=\"tktSrt(7,'client_name')\">Client ↕</th>\r\n      <th onclick=\"tktSrt(7,'client_id')\">Client ID ↕</th>\r\n      <th onclick=\"tktSrt(7,'activation_status')\">Activation ↕</th>\r\n      <th onclick=\"tktSrt(7,'platform')\">Platform ↕</th>\r\n      <th>Invoice #</th>\r\n      <th onclick=\"tktSrt(7,'invoice_date')\">Date ↕</th>\r\n      <th>Platform Ticket #</th>\r\n      <th onclick=\"tktSrt(7,'status')\">Status ↕</th>\r\n      <th onclick=\"tktSrt(7,'invoice_amount')\">Amount ↕</th>\r\n      <th onclick=\"tktSrt(7,'ageing_days')\">Ageing ↕</th>\r\n      <th onclick=\"tktSrt(7,'kam')\">KAM ↕</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb7\"></tbody>\r\n  </table></div>\r\n</div>\r\n-->\r\n\r\n<!-- ══ S8: CREDENTIAL VERIFICATION PENDING ══ -->\r\n<div id=\"s8\" class=\"sec\">\r\n  <div class=\"fb filterbar\" id=\"fb8\">\r\n    <div class=\"filter-group\">\r\n      <span class=\"flbl\">Status:</span>\r\n      <span class=\"fp on\" data-f8=\"all\" onclick=\"setCredFilter('all',this)\">All</span>\r\n      <span class=\"fp\" data-f8=\"uv\" onclick=\"setCredFilter('uv',this)\">Under Verification</span>\r\n      <span class=\"fp\" data-f8=\"uq\" onclick=\"setCredFilter('uq',this)\">Upload Queued</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"kpi-strip\">\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Under Verification</div><div class=\"kpi-big a\" id=\"k8-uv\">–</div><div class=\"kpi-small\" id=\"k8-uv-c\">– clients</div></div>\r\n    <div class=\"kpi\"><div class=\"kpi-lbl\">Upload Queued</div><div class=\"kpi-big b\" id=\"k8-uq\">–</div><div class=\"kpi-small\" id=\"k8-uq-c\">– clients</div></div>\r\n  </div>\r\n  <div class=\"tbl-wrap\"><table>\r\n    <thead><tr>\r\n      <th>Status</th>\r\n      <th>Client Name</th>\r\n      <th>Client ID</th>\r\n      <th>GST Number</th>\r\n      <th>Password Updated On</th>\r\n    </tr></thead>\r\n    <tbody id=\"tb8\"></tbody>\r\n  </table></div>\r\n</div>\r\n\r\n<div class=\"footer\">ARPFlow EMS · NAKAD · Internal use only · <span class=\"ems-date\">–</span></div>\r\n</div>\r\n\r\n<!-- Loading / error overlays -->\r\n<div id=\"ems-loading\">\r\n  <div class=\"ld-inner\">\r\n    <div class=\"ld-spinner\"></div>\r\n    <div class=\"ld-txt\">Loading live error data…</div>\r\n  </div>\r\n</div>\r\n<div id=\"ems-err\">\r\n  <div class=\"ld-inner\">\r\n    <div class=\"ld-txt err-txt\">Failed to load data.</div>\r\n    <div class=\"ld-txt muted\" id=\"ems-err-msg\" style=\"font-size:11px;\"></div>\r\n    <button class=\"retry-btn\" onclick=\"fetchAndInit()\">Retry</button>\r\n  </div>\r\n</div>\r\n\r\n";

// `root` is the ShadowRoot the markup is mounted into. All original
// document.getElementById/querySelectorAll/addEventListener calls were rebound
// to it. Inline on* handlers in the markup resolve the functions below off window.
// `defaultKam` (from the saved login) pre-seeds every section's KAM filter, if given.
export function initEms(root, defaultKam) {

// ── API config ──────────────────────────────────────────────────────────────
// Single base URL for every EMS API call — change the environment here only.
// Follows REACT_APP_BACKEND_BASE_URL like the rest of the dashboard (dev/prod builds set it);
// falls back to prod when unset.
const BASE_SERVER_URL = (process.env.REACT_APP_BACKEND_BASE_URL || 'https://api.nakad.co/qsync') + '/api/ems';
// const BASE_SERVER_URL = 'http://localhost:8082/qsync/api/ems';
const API_URL = BASE_SERVER_URL + '/ExternalClientAlerts';
const PENDING_CREDS_URL = BASE_SERVER_URL + '/GstCredentials/pending-verification';
const API_HEADERS = {
  'X-qsync-Access-Key-Id': 'a6e6ade89dd4a801d59786283256fbc5',
  'X-qsync-Secret-Access-Key': '4eb0a42fffbd0ecac6ccff0d5ccb21574ca485547a91e93aeb08c0da21b7041e',
};
const API_REQUEST_OPTIONS = {
  method: 'GET',
  mode: 'cors',
  credentials: 'omit',
  headers: API_HEADERS,
  redirect: 'follow',
  referrerPolicy: 'no-referrer',
};

// ── Static lookup maps (kept in JS — only data changes on API refresh) ──────

const CATEGORY_MAP = {
  'PORTAL_CRED_EXPIRED':'Red Flag','OTP_NOT_RECEIVED':'Red Flag','OTP_INCORRECT':'Red Flag',
  'EMAIL_AUTH_EXPIRED':'Red Flag','PORTAL_ACCESS_ISSUE':'Red Flag','PORTAL_INTERNAL_ISSUE':'Red Flag',
  'GST_PASSWORD_INCORRECT':'Red Flag','GST_PASSWORD_EXPIRED':'Red Flag','STALE_GST_INVOICE_DATA':'Red Flag','STALE_GST_EINVOICE_DATA':'Red Flag',
  'LAST_PLATFORM_SYNC':'Red Flag',
  'HIGH_NO_GRN_RATE':'Operational Error','STALE_GRN_DATA':'Operational Error','STALE_EINVOICE_DATA':'Operational Error',
};

const LABEL_MAP = {
  'PORTAL_CRED_EXPIRED':'Creds expired','OTP_NOT_RECEIVED':'OTP not received','OTP_INCORRECT':'OTP incorrect',
  'EMAIL_AUTH_EXPIRED':'Email auth expired','PORTAL_ACCESS_ISSUE':'Portal access issue',
  'PORTAL_INTERNAL_ISSUE':'Portal internal issue','GST_PASSWORD_INCORRECT':'GST password incorrect','GST_PASSWORD_EXPIRED':'GST password expired',
  'LAST_PLATFORM_SYNC':'Platform sync not done',
  'HIGH_NO_GRN_RATE':'High No-GRN rate','STALE_GRN_DATA':'Stale GRN data',
  'STALE_EINVOICE_DATA':'Stale E-Invoice data','STALE_GST_INVOICE_DATA':'Stale GST E-Invoice data',
  'STALE_GST_EINVOICE_DATA':'Stale GST E-Invoice data',
};

const SELF_UPLOAD_CLIENTS = new Set([
  'Dairy Classic',
  'Kennel Kitchen',
  'CHHEDA SPECIALITIES FOODS',
  'Oxbow',
  'OXBOWS BRANDS',
]);

// ── Mutable data — populated by fetchAndInit() ───────────────────────────────
let RF = [], OPS = [], ALL = [], RF_RES = [], OPS_RES = [];
let PENDING_CREDS = [];
let CRED_FILTER = 'all'; // 'all' | 'uv' | 'uq'

const SEV={severe:0,warn:1,unclassified:2};

// ── State ────────────────────────────────────────────────────────────────────
const ST={
  1:{filters:new Set(['activation_active']),sc:'sev',sa:true},
  2:{filters:new Set(['activation_active'])},
  3:{filters:new Set(['activation_active']),sc:'sev',sa:true},
  4:{filters:new Set(['activation_active'])},
  5:{filters:new Set(['activation_active']),sc:'category',sa:true}
};

// ── Filter helpers ───────────────────────────────────────────────────────────
const GROUPS={
  sev:['all','red','yellow'],
  kam:['TBD'],
  cat:['Red Flag','Operational Error'],
  activation:['activation_all','activation_trial','activation_active'],
};
const PLATFORM_FILTER_PREFIX='platform:';
const ERROR_FILTER_PREFIX='error:';
const CLIENT_FILTER_PREFIX='client:';
const CAM_FILTER_PREFIX='cam:';

function groupOf(f){
  if(f&&f.startsWith(PLATFORM_FILTER_PREFIX))return'platform';
  if(f&&f.startsWith(ERROR_FILTER_PREFIX))return'error';
  if(f&&f.startsWith(CLIENT_FILTER_PREFIX))return'client';
  if(f&&f.startsWith(CAM_FILTER_PREFIX))return'kam';
  for(const[g,vals]of Object.entries(GROUPS))if(vals.includes(f))return g;
  return null;
}

function platformFilterValue(v){return`${PLATFORM_FILTER_PREFIX}${v}`;}
function errorFilterValue(v){return`${ERROR_FILTER_PREFIX}${v}`;}
function clientFilterValue(v){return`${CLIENT_FILTER_PREFIX}${v}`;}
function camFilterValue(v){return`${CAM_FILTER_PREFIX}${v}`;}
function platformValueFromFilter(f){return f.slice(PLATFORM_FILTER_PREFIX.length);}
function errorValueFromFilter(f){return f.slice(ERROR_FILTER_PREFIX.length);}
function clientValueFromFilter(f){return f.slice(CLIENT_FILTER_PREFIX.length);}
function camValueFromFilter(f){return f.startsWith(CAM_FILTER_PREFIX)?f.slice(CAM_FILTER_PREFIX.length):f;}
function displayPlatform(r){return(r.platform||'GST').trim();}
function errorLabelForCode(code){return LABEL_MAP[code]||code;}
function clientNameForFilter(r){return r.client_name||r.client||'';}
function activationStatus(r){return(r.activation_status||'').toString().trim().toLowerCase();}
function camNameFromRecord(r){return(r.cam_name||r.camName||r.kam_name||r.kamName||r.cam_email||r.camEmail||r.kam_email||r.kamEmail||r.kam||'TBD').toString().trim()||'TBD';}
function escHtml(s){
  return String(s)
    .replaceAll('&','&amp;')
    .replaceAll('<','&lt;')
    .replaceAll('>','&gt;')
    .replaceAll('"','&quot;');
}

function sortPlatforms(values){
  const preferred=['Instamart','Zepto','Blinkit','Flipkart','Amazon','GST'];
  return [...values].sort((a,b)=>{
    const ai=preferred.indexOf(a), bi=preferred.indexOf(b);
    if(ai!==-1||bi!==-1){
      if(ai===-1)return 1;
      if(bi===-1)return -1;
      return ai-bi;
    }
    return a.localeCompare(b);
  });
}

function sortErrorCodes(values){
  return [...values].sort((a,b)=>errorLabelForCode(a).localeCompare(errorLabelForCode(b))||a.localeCompare(b));
}

function sortClients(values){
  return [...values].sort((a,b)=>a.localeCompare(b));
}

function isStaleGstEinvoiceError(code){
  return code==='STALE_GST_INVOICE_DATA'||code==='STALE_GST_EINVOICE_DATA';
}

function applyF(data,filters){
  const active=[...filters].filter(f=>f!=='all');
  if(!active.length)return data;
  const byGroup={};
  active.forEach(f=>{const g=groupOf(f);if(g){if(!byGroup[g])byGroup[g]=[];byGroup[g].push(f);}});
  return data.filter(r=>{
    return Object.entries(byGroup).every(([g,vals])=>{
      if(g==='sev')return vals.some(v=>v==='red'?r.sev==='severe':v==='yellow'?r.sev==='warn':true);
      if(g==='kam')return vals.some(v=>{
        return r.kam===camValueFromFilter(v);
      });
      if(g==='platform')return vals.some(v=>displayPlatform(r)===platformValueFromFilter(v));
      if(g==='error')return vals.some(v=>r.error_code===errorValueFromFilter(v));
      if(g==='client')return vals.some(v=>clientNameForFilter(r)===clientValueFromFilter(v));
      if(g==='cat')return vals.includes(r.category);
      if(g==='activation')return vals.some(v=>{
        if(v==='activation_all')return true;
        if(v==='activation_trial')return activationStatus(r)==='trial';
        if(v==='activation_active')return activationStatus(r)==='active';
        return true;
      });
      return true;
    });
  });
}

function dropdownOptionsHtml(n,items,buildFilter,fmt){
  if(!items.length)return'<div class="filter-empty">No options</div>';
  return items.map(item=>{
    const f=buildFilter(item);
    return `<label class="filter-option"><input type="checkbox" data-f="${escHtml(f)}" onchange="setDropdownFilter(${n},this.dataset.f,this.checked)"><span>${escHtml(fmt(item))}</span></label>`;
  }).join('');
}

function clientDropdownHtml(n,clients){
  const options=[
    '<button type="button" class="filter-option client-option" data-client="" onclick="setClientFilter('+n+',this.dataset.client)">All clients</button>',
    ...clients.map(client=>`<label class="filter-option client-option" data-client="${escHtml(client)}"><input type="checkbox" data-f="${escHtml(clientFilterValue(client))}" onchange="setDropdownFilter(${n},this.dataset.f,this.checked)"><span>${escHtml(client)}</span></label>`)
  ].join('');
  return `<input class="client-search" id="fs${n}" type="search" placeholder="Search client..." oninput="filterClientOptions(${n},this.value)" onclick="event.stopPropagation()">${options}`;
}

function renderDynamicFilters(){
  const filterSources={
    1:[...RF,...RF_RES],
    2:[...RF,...RF_RES],
    3:[...OPS,...OPS_RES],
    4:[...OPS,...OPS_RES],
    5:[...ALL,...RF_RES,...OPS_RES]
  };
  Object.entries(filterSources).forEach(([key,records])=>{
    const n=Number(key);
    const fb=root.getElementById('fb'+n);
    if(!fb)return;
    fb.querySelectorAll('[data-dynamic="1"]').forEach(el=>el.remove());
    fb.querySelectorAll('.fp').forEach(el=>{
      const f=el.getAttribute('data-f');
      if(groupOf(f)==='platform')el.remove();
    });
    const platforms=sortPlatforms([...new Set(records.map(displayPlatform).filter(Boolean))]);
    const errors=sortErrorCodes([...new Set(records.map(r=>r.error_code).filter(Boolean))]);
    const clients=sortClients([...new Set(records.map(clientNameForFilter).filter(Boolean))]);
    const owners=sortClients([...new Set(records.map(r=>r.kam).filter(Boolean))]);

    const ownerPanel=root.getElementById(`fp-${n}-kam`);
    const platformPanel=root.getElementById(`fp-${n}-platform`);
    const errorPanel=root.getElementById(`fp-${n}-error`);
    const clientPanel=root.getElementById(`fp-${n}-client`);
    if(ownerPanel)ownerPanel.innerHTML=dropdownOptionsHtml(n,owners,camFilterValue,v=>v);
    if(platformPanel)platformPanel.innerHTML=dropdownOptionsHtml(n,platforms,platformFilterValue,v=>v);
    if(errorPanel)errorPanel.innerHTML=dropdownOptionsHtml(n,errors,errorFilterValue,errorLabelForCode);
    if(clientPanel)clientPanel.innerHTML=clientDropdownHtml(n,clients);
    syncFilters(n);
  });
}

// ── Render helpers ───────────────────────────────────────────────────────────
function src(n){return n===1||n===2?RF:n===3||n===4?OPS:ALL;}
function kamC(k){return{Nilesh:'av-N',Prerna:'av-P',Shivam:'av-S',Vishal:'av-V'}[k]||'av-D';}
function kamI(k){return(k&&k!=='TBD')?k.slice(0,2).toUpperCase():'?';}
function gstNo(r){return(r.gst_number||r.gstNumber||'').toString().trim();}
function scopeHtml(r){
  if(r.platform)return r.platform;
  const g=gstNo(r);
  return g?`<span class="muted">GST</span> &middot; <span class="fw6">${g}</span>`:'<span class="muted">GST</span>';
}
function scopeText(r){
  if(r.platform)return r.platform;
  const g=gstNo(r);
  return g?`GST (${g})`:'GST';
}
function sevPill(s){return s==='severe'?'<span class="pill p-r">Red</span>':s==='warn'?'<span class="pill p-a">Yellow</span>':'<span class="pill p-g">New</span>';}
function sevDot(s){return s==='severe'?'d-r':s==='warn'?'d-a':'d-g';}
function errPill(r){
  const code=r.error_code||'';
  const label=r.error_label||code;
  const c=code.includes('CRED')||code.includes('OTP')||code.includes('AUTH')||code.includes('GST_P')?'p-p':
    code.includes('NO_GRN')?'p-a':code.includes('STALE_G')||code.includes('STALE_E')?'p-o':
    code.includes('INTERNAL')||code.includes('ACCESS')||code.includes('PLATFORM_SYNC')?'p-b':'p-g';
  const selfUploadTag=isStaleGstEinvoiceError(code)&&r.self_upload?' <span class="pill p-b">Self Upload</span>':'';
  const taskTypeTag=r.task_type?` <span class="pill p-g" style="font-size:9px;">${r.task_type}</span>`:'';
  return`<span class="pill ${c}">${label}</span>${taskTypeTag}${selfUploadTag}`;
}
function catPill(c){return c==='Red Flag'?'<span class="pill p-r" style="font-size:9px;">Red Flag</span>':'<span class="pill p-a" style="font-size:9px;">Ops</span>';}
function daysStr(d){
  if(d>7)return`<span class="age-r">${d}d !</span>`;
  if(d>3)return`<span class="age-r">${d}d</span>`;
  if(d>0)return`<span class="muted">${d}d</span>`;
  if(d===0)return`<span class="age-t">Today</span>`;
  return`<span class="age-t">New</span>`;
}

// ── Table render ─────────────────────────────────────────────────────────────
function renderTbl(n,showCat){
  const s=ST[n]; const data=applyF(src(n),s.filters);
  const sorted=[...data].sort((a,b)=>{
    let av=a[s.sc],bv=b[s.sc];
    if(s.sc==='sev'){av=SEV[av]??3;bv=SEV[bv]??3;}
    if(s.sc==='category')return s.sa?(a.category==='Red Flag'?-1:1):-(a.category==='Red Flag'?-1:1);
    if(typeof av==='string')return s.sa?av.localeCompare(bv):bv.localeCompare(av);
    return s.sa?av-bv:bv-av;
  });
  const tbody=root.getElementById('tb'+n);
  if(!sorted.length){tbody.innerHTML=`<tr><td colspan="${showCat?7:6}" class="no-rows">No errors match this filter</td></tr>`;return;}
  tbody.innerHTML=sorted.map(r=>`<tr>
    ${showCat?`<td>${catPill(r.category)}</td>`:''}
    <td><span class="dot ${sevDot(r.sev)}"></span>${sevPill(r.sev)}</td>
    <td class="fw6">${clientLabel(r)}</td>
    <td>${scopeHtml(r)}</td>
    <td>${errPill(r)}</td>
    <td>${daysStr(r.days)}</td>
    <td><span class="ava ${kamC(r.kam)}">${kamI(r.kam)}</span><span class="muted">${r.kam}</span></td>
  </tr>`).join('');
}

// ── KPI update ───────────────────────────────────────────────────────────────
function updateKPI(n){
  const data=applyF(src(n),ST[n].filters);
  const red=data.filter(r=>r.sev==='severe'), yel=data.filter(r=>r.sev==='warn'), unc=data.filter(r=>r.sev==='unclassified');
  if(n===1){
    root.getElementById('k1-rn').textContent=red.length;
    root.getElementById('k1-rc').textContent=new Set(red.map(clientKey)).size+' clients';
    root.getElementById('k1-yn').textContent=yel.length;
    root.getElementById('k1-yc').textContent=new Set(yel.map(clientKey)).size+' clients';
    root.getElementById('k1-un').textContent=unc.length;
    root.getElementById('k1-uc').textContent=new Set(unc.map(clientKey)).size+' clients';
    const res=applyF(RF_RES,ST[1].filters);
    root.getElementById('k1-gn').textContent=res.length;
    root.getElementById('k1-gc').textContent=new Set(res.map(clientKey)).size+' clients';
  } else if(n===3){
    root.getElementById('k3-rn').textContent=red.length;
    root.getElementById('k3-rc').textContent=new Set(red.map(clientKey)).size+' clients';
    root.getElementById('k3-yn').textContent=yel.length;
    root.getElementById('k3-yc').textContent=new Set(yel.map(clientKey)).size+' clients';
    const res=applyF(OPS_RES,ST[3].filters);
    root.getElementById('k3-gn').textContent=res.length;
    root.getElementById('k3-gc').textContent=new Set(res.map(clientKey)).size+' clients';
  }
}

// ── Heatmap helper ───────────────────────────────────────────────────────────
function hcell(cell){
  const red=cell?.red||0;
  const yellow=cell?.yellow||0;
  if(!red&&!yellow)return'<span class="hcell-empty">-</span>';
  return`<span class="hcell" title="${red} red, ${yellow} yellow"><span class="hseg ${red?'hseg-r':'hseg-zero'}">${red||'-'}</span><span class="hseg ${yellow?'hseg-y':'hseg-zero'}">${yellow||'-'}</span></span>`;
}

// ── Analysis builders ────────────────────────────────────────────────────────
function errorDisplayLabel(r){
  return r.error_label||errorLabelForCode(r.error_code)||r.error_code||'Unknown error';
}

function buildHeatmap(records,preferredPortals=[]){
  const portals=sortPlatforms([...new Set([
    ...preferredPortals,
    ...records.map(r=>displayPlatform(r)).filter(Boolean)
  ])]);
  const errTypes=sortClients([...new Set(records.map(errorDisplayLabel).filter(Boolean))]);
  const counts={};
  portals.forEach(p=>{counts[p]={};errTypes.forEach(e=>{counts[p][e]={red:0,yellow:0,total:0};});});
  records.forEach(r=>{
    const p=displayPlatform(r);
    const e=errorDisplayLabel(r);
    if(!counts[p])counts[p]={};
    if(!counts[p][e])counts[p][e]={red:0,yellow:0,total:0};
    if(r.sev==='severe')counts[p][e].red++;
    else if(r.sev==='warn')counts[p][e].yellow++;
    counts[p][e].total++;
  });
  const activePorts=portals.filter(p=>errTypes.some(e=>((counts[p]||{})[e]?.total||0)>0));
  const activeErrs=errTypes.filter(e=>portals.some(p=>((counts[p]||{})[e]?.total||0)>0));
  const rowTotal=p=>activeErrs.reduce((sum,e)=>sum+((counts[p]||{})[e]?.total||0),0);
  const colTotal=e=>activePorts.reduce((sum,p)=>sum+((counts[p]||{})[e]?.total||0),0);
  activePorts.sort((a,b)=>rowTotal(b)-rowTotal(a)||a.localeCompare(b));
  activeErrs.sort((a,b)=>colTotal(b)-colTotal(a)||a.localeCompare(b));
  let max={p:null,e:null,total:-1};
  activePorts.forEach(p=>activeErrs.forEach(e=>{
    const total=(counts[p]||{})[e]?.total||0;
    if(total>max.total)max={p,e,total};
  }));
  if(max.p){
    activePorts.splice(activePorts.indexOf(max.p),1);
    activePorts.unshift(max.p);
  }
  if(max.e){
    activeErrs.splice(activeErrs.indexOf(max.e),1);
    activeErrs.unshift(max.e);
  }
  return{portals,counts,activePorts,activeErrs};
}

function renderHeatmap(portals,counts,activePorts,activeErrs){
  let h=`<div class="hmap-wrap"><table class="hmap"><thead><tr><th>Portal</th>${activeErrs.map(e=>`<th>${e}</th>`).join('')}</tr></thead><tbody>`;
  (activePorts.length?activePorts:portals).forEach(p=>{h+=`<tr><td>${p}</td>${activeErrs.map(e=>`<td>${hcell((counts[p]||{})[e])}</td>`).join('')}</tr>`;});
  h+='</tbody></table></div>';
  return h;
}

function analysisRows(data){
  return data.filter(r=>r.sev==='severe'||r.sev==='warn');
}

function sevSummary(records){
  const red=records.filter(r=>r.sev==='severe').length;
  const yellow=records.filter(r=>r.sev==='warn').length;
  if(red&&yellow)return`${red} red · ${yellow} yellow`;
  if(red)return`${red} red`;
  return`${yellow} yellow`;
}

function buildRFAnalysis(){
  const data=applyF(RF,ST[2].filters);
  const analysis=analysisRows(data);
  const {portals,counts,activePorts,activeErrs}=buildHeatmap(analysis,['Zepto','Instamart','Blinkit','GST']);
  const h=renderHeatmap(portals,counts,activePorts,activeErrs);
  root.getElementById('a-rf-hmap').innerHTML=activePorts.length?h:'<div class="empty-s">No red/yellow red flag errors match this filter</div>';
  const cc={};
  analysis.forEach(r=>{cc[r.client]=(cc[r.client]||0)+1;});
  const critical=Object.entries(cc).filter(([,n])=>n>=3).sort((a,b)=>b[1]-a[1]);
  const ccEl=root.getElementById('a-rf-cc');
  ccEl.innerHTML=critical.length?critical.map(([c,n])=>{const clientRows=analysis.filter(r=>r.client===c);const kam=clientRows[0]?.kam||'';const types=[...new Set(clientRows.map(r=>r.error_label))].join(', ');return`<div class="cc-row"><div><div class="cc-name">${c}</div><div class="cc-meta">KAM: ${kam} · ${types}</div></div><span class="pill p-r">${sevSummary(clientRows)}</span></div>`;}).join(''):'<div class="empty-s">No clients with 3+ red/yellow red flag errors match this filter</div>';
  const lp=analysis.filter(r=>r.days>7).sort((a,b)=>b.days-a.days);
  root.getElementById('a-rf-lp').innerHTML=lp.length?lp.map(r=>`<div class="lp-row"><div class="lp-days">${r.days}d</div><div style="flex:1"><div class="lp-client">${r.client} · ${scopeText(r)}</div><div class="lp-detail">${r.error_label} · KAM: ${r.kam}</div></div>${sevPill(r.sev)}</div>`).join(''):'<div class="empty-s">No red/yellow red flag errors open for more than 7 days</div>';
}

function buildOpsAnalysis(){
  const data=applyF(OPS,ST[4].filters);
  const analysis=analysisRows(data);
  const {portals,counts,activePorts,activeErrs}=buildHeatmap(analysis,['Instamart','Blinkit','Zepto','Flipkart','Amazon']);
  const h=renderHeatmap(portals,counts,activePorts,activeErrs);
  root.getElementById('a-ops-hmap').innerHTML=activePorts.length?h:'<div class="empty-s">No red/yellow ops errors match this filter</div>';
  const cc={};
  analysis.forEach(r=>{cc[r.client]=(cc[r.client]||0)+1;});
  const critical=Object.entries(cc).filter(([,n])=>n>=3).sort((a,b)=>b[1]-a[1]);
  root.getElementById('a-ops-cc').innerHTML=critical.length?critical.map(([c,n])=>{const clientRows=analysis.filter(r=>r.client===c);const kam=clientRows[0]?.kam||'';const types=[...new Set(clientRows.map(r=>r.error_label))].join(', ');return`<div class="cc-row"><div><div class="cc-name">${c}</div><div class="cc-meta">KAM: ${kam} · ${types}</div></div><span class="pill p-r">${sevSummary(clientRows)}</span></div>`;}).join(''):'<div class="empty-s">No clients with 3+ red/yellow ops errors match this filter</div>';
  const lp=analysis.filter(r=>r.days>5).sort((a,b)=>b.days-a.days);
  root.getElementById('a-ops-lp').innerHTML=lp.length?lp.map(r=>`<div class="lp-row"><div class="lp-days">${r.days}d</div><div style="flex:1"><div class="lp-client">${r.client} · ${r.platform}</div><div class="lp-detail">${r.error_label} · KAM: ${r.kam}</div></div>${sevPill(r.sev)}</div>`).join(''):'<div class="empty-s">No red/yellow ops errors open for more than 5 days</div>';
}

// ── Resolved section ─────────────────────────────────────────────────────────
function toggleRes(n){
  const body=root.getElementById('res-body-'+n);
  const arr=root.getElementById('res-arr-'+n);
  const open=body.style.display!=='none'&&body.style.display!=='';
  body.style.display=open?'none':'block';
  arr.style.transform=open?'':'rotate(90deg)';
}

function renderResolved(n){
  const srcMap={1:RF_RES,3:OPS_RES,5:[...RF_RES,...OPS_RES]};
  const data=applyF(srcMap[n]||[],ST[n].filters);
  const tbl=root.getElementById('res-tbl-'+n);
  const cnt=root.getElementById('res-cnt-'+n);
  if(!tbl)return;
  cnt.textContent='('+data.length+')';
  if(!data.length){
    tbl.innerHTML='<tr><td class="no-rows" colspan="6">No resolved errors match this filter</td></tr>';
    return;
  }
  const showCat=(n===5);
  const cols=showCat?7:6;
  const hdr=`<thead><tr>
    ${showCat?'<th>Category</th>':''}
    <th>Client</th>
    <th>Platform</th>
    <th>Error</th>
    <th>Active for</th>
    <th>Resolved</th>
    <th>KAM</th>
  </tr></thead>`;
  const rows=data.map(r=>{
    const activeFor=r.days>0?r.days+'d':r.days===0?'<span class="age-t">Same day</span>':'<span class="age-t">–</span>';
    const resolvedStr=r.resolved_at?r.resolved_at.toLocaleDateString('en-GB',{day:'numeric',month:'short'}):'–';
    return`<tr>
      ${showCat?`<td>${catPill(r.category)}</td>`:''}
      <td class="fw6">${r.client}</td>
      <td>${scopeHtml(r)}</td>
      <td>${errPill(r)}</td>
      <td><span class="muted">${activeFor}</span></td>
      <td><span class="pill p-gr">✓ Resolved</span> <span class="muted" style="font-size:10px;">${resolvedStr}</span></td>
      <td><span class="ava ${kamC(r.kam)}">${kamI(r.kam)}</span><span class="muted">${r.kam}</span></td>
    </tr>`;
  }).join('');
  tbl.innerHTML=hdr+'<tbody>'+rows+'</tbody>';
}

// ── Refresh / sync ───────────────────────────────────────────────────────────
function refresh(n){
  if(n===1){updateKPI(1);renderTbl(1,false);renderResolved(1);}
  else if(n===2){buildRFAnalysis();}
  else if(n===3){updateKPI(3);renderTbl(3,false);renderResolved(3);}
  else if(n===4){buildOpsAnalysis();}
  else if(n===6){refreshTickets(6);}
  else if(n===7){refreshTickets(7);}
  else{renderTbl(5,true);renderResolved(5);}
}

function selectedDropdownFilters(n,group){
  return [...ST[n].filters].filter(f=>groupOf(f)===group);
}

function dropdownDisplayValue(f){
  const g=groupOf(f);
  if(g==='platform')return platformValueFromFilter(f);
  if(g==='error')return errorLabelForCode(errorValueFromFilter(f));
  if(g==='kam')return camValueFromFilter(f);
  return f;
}

function dropdownLabel(n,group,defaultLabel){
  const vals=selectedDropdownFilters(n,group);
  if(vals.length===1)return dropdownDisplayValue(vals[0]);
  if(vals.length>1){
    const suffix=group==='kam'?'owners':group==='platform'?'platforms':'errors';
    return `${vals.length} ${suffix}`;
  }
  return defaultLabel;
}

function syncDropdowns(n){
  ['kam','platform','error'].forEach(group=>{
    const btn=root.getElementById(`fm-${n}-${group}`);
    const panel=root.getElementById(`fp-${n}-${group}`);
    if(!btn||!panel)return;
    const defaults={kam:'Owner',platform:'Platform',error:'Error'};
    const selected=selectedDropdownFilters(n,group);
    btn.textContent=dropdownLabel(n,group,defaults[group]);
    btn.classList.toggle('on',selected.length>0);
    panel.querySelectorAll('input[type="checkbox"][data-f]').forEach(input=>{
      input.checked=ST[n].filters.has(input.dataset.f);
    });
  });
}

function syncFilters(n){
  const filters=ST[n].filters;
  root.getElementById('fb'+n).querySelectorAll('.fp').forEach(el=>{
    const f=el.getAttribute('data-f');
    if(!f)return;
    const isAll=(f==='all');
    const active=isAll?(!filters.size||filters.has('all')):filters.has(f);
    el.classList.toggle('on',active);
  });
  const clientFilters=selectedDropdownFilters(n,'client');
  const clientBtn=root.getElementById(`fm-${n}-client`);
  if(clientBtn){
    clientBtn.textContent=clientFilters.length===1?clientValueFromFilter(clientFilters[0]):clientFilters.length>1?`${clientFilters.length} clients`:'All clients';
    clientBtn.classList.toggle('on',clientFilters.length>0);
  }
  const clientSearch=root.getElementById('fs'+n);
  if(clientSearch&&!clientSearch.value)filterClientOptions(n,'');
  root.getElementById(`fp-${n}-client`)?.querySelectorAll('.client-option').forEach(el=>{
    const f=el.dataset.client?clientFilterValue(el.dataset.client):'';
    const active=el.dataset.client?filters.has(f):clientFilters.length===0;
    el.classList.toggle('on',active);
    const input=el.querySelector('input[type="checkbox"][data-f]');
    if(input)input.checked=filters.has(input.dataset.f);
  });
  syncDropdowns(n);
}

function syncPills(n){
  syncFilters(n);
}

function setF(n,f,el){
  const s=ST[n];
  if(f==='all'){
    s.filters=new Set(['all']);
  } else {
    s.filters.delete('all');
    if(s.filters.has(f)){
      s.filters.delete(f);
      if(!s.filters.size)s.filters.add('all');
    } else {
      s.filters.add(f);
    }
  }
  syncFilters(n);
  refresh(n);
}

function setActivationFilter(n,f){
  const s=ST[n];
  [...s.filters].filter(v=>groupOf(v)==='activation').forEach(v=>s.filters.delete(v));
  s.filters.delete('all');
  s.filters.add(f);
  syncFilters(n);
  refresh(n);
}

function setDropdownFilter(n,f,checked){
  const s=ST[n];
  s.filters.delete('all');
  if(checked)s.filters.add(f);
  else s.filters.delete(f);
  if(!s.filters.size)s.filters.add('all');
  syncFilters(n);
  refresh(n);
}

function setClientFilter(n,value){
  const s=ST[n];
  [...s.filters].filter(f=>groupOf(f)==='client').forEach(f=>s.filters.delete(f));
  if(value){
    s.filters.delete('all');
    s.filters.add(clientFilterValue(value));
  } else if(!s.filters.size){
    s.filters.add('all');
  }
  syncFilters(n);
  refresh(n);
}

function filterClientOptions(n,query){
  const q=(query||'').trim().toLowerCase();
  const panel=root.getElementById(`fp-${n}-client`);
  if(!panel)return;
  panel.querySelectorAll('.client-option').forEach(btn=>{
    const name=(btn.dataset.client||'').toLowerCase();
    btn.style.display=!q||!name||name.includes(q)?'flex':'none';
  });
}

function closeFilterMenus(){
  root.querySelectorAll('.filter-menu.open').forEach(el=>el.classList.remove('open'));
}

function toggleFilterMenu(n,group,event){
  if(event)event.stopPropagation();
  const panel=root.getElementById(`fp-${n}-${group}`);
  if(!panel)return;
  const menu=panel.closest('.filter-menu');
  const wasOpen=menu.classList.contains('open');
  closeFilterMenus();
  menu.classList.toggle('open',!wasOpen);
  if(!wasOpen&&group==='client'){
    const search=root.getElementById('fs'+n);
    if(search){
      search.value='';
      filterClientOptions(n,'');
      setTimeout(()=>search.focus(),0);
    }
  }
}

root.addEventListener('click',e=>{
  if(!e.target.closest('.filter-menu'))closeFilterMenus();
});

root.addEventListener('keydown',e=>{
  if(e.key==='Escape')closeFilterMenus();
});

function srt(n,col){
  const s=ST[n];
  if(s.sc===col)s.sa=!s.sa; else{s.sc=col;s.sa=true;}
  if(n===1||n===3)renderTbl(n,false);
  else if(n===5)renderTbl(5,true);
}

function showSec(id,el){
  root.querySelectorAll('.sec').forEach(s=>s.classList.remove('active'));
  root.querySelectorAll('.ni').forEach(n=>n.classList.remove('active'));
  root.getElementById(id).classList.add('active');
  el.classList.add('active');
}

// ── Data transform ───────────────────────────────────────────────────────────
const MS_PER_DAY=86400000;
function daysBetweenDates(startValue,endValue,fallbackDays){
  if(startValue){
    const startDate=new Date(startValue);
    if(!Number.isNaN(startDate.getTime())){
      const endDate=endValue&&!Number.isNaN(endValue.getTime())?endValue:new Date();
      const startDay=new Date(startDate.getFullYear(),startDate.getMonth(),startDate.getDate());
      const endDay=new Date(endDate.getFullYear(),endDate.getMonth(),endDate.getDate());
      return Math.max(0,Math.floor((endDay-startDay)/MS_PER_DAY));
    }
  }
  const n=Number(fallbackDays);
  if(Number.isFinite(n))return Math.max(0,Math.floor(n));
  return 0;
}

function clientLabel(r){
  const trialTag=r.is_trial?' <span class="pill p-o" style="font-size:9px;">TRIAL</span>':'';
  return r.client+trialTag;
}

function clientKey(r){
  return r.client_id?`${r.client}::${r.client_id}`:r.client;
}

function isSelfUploadClient(clientName){
  return SELF_UPLOAD_CLIENTS.has(clientName);
}

function transformRecord(r){
  const STATUS_SEV={RED:'severe',YELLOW:'warn'};
  const ra=r.resolved_at?new Date(r.resolved_at):null;
  const isResolved=(r.status==='GREEN');
  const days=daysBetweenDates(r.first_occurred_at||r.firstOccurredAt,isResolved?ra:null,r.days);
  const rawClient=r.client_name||'';
  const clientId=r.client_id||r.clientId||r.clientid||'';
  const taskType=(r.task_type||r.taskType||'').toString().trim();
  const act=(r.activation_status||r.activationStatus||'').toString().trim().toLowerCase();
  return{
    client:clientId?`${rawClient} [${clientId}]`:rawClient,
    client_name:rawClient,
    client_id:clientId,
    platform:(r.portal||'').trim(),
    gst_number:r.gst_number||r.gstNumber||'',
    error_code:r.error_code||'',
    error_label:LABEL_MAP[r.error_code]||r.notification_message||r.error_code||'',
    sev:isResolved?'resolved':(STATUS_SEV[r.status]||'unclassified'),
    days,
    self_upload:isSelfUploadClient(rawClient),
    task_type:taskType,
    activation_status:act,
    cam_email:r.cam_email||r.camEmail||r.kam_email||r.kamEmail||'',
    is_trial:act==='trial',
    kam:camNameFromRecord(r),
    category:CATEGORY_MAP[r.error_code]||'Unknown',
    resolved_at:ra,
  };
}

// ── Action Tickets ───────────────────────────────────────────────────────────
const TICKETS_API_URL = BASE_SERVER_URL + '/ActionTickets';
let TICKETS_GRN = [], TICKETS_OD = [];

const TICKET_ISSUE_LABELS = {
  grn_missing: 'No GRN',
  grn_short: 'Short GRN',
  unbooked_invoice: 'Rejected',
  payment_overdue: 'Payment Overdue',
};

const TST = {
  6: { sc: 'ageing_days', sa: false, clients: new Set(), clientIds: new Set(), issueTypes: new Set(), statuses: new Set(), kams: new Set(), platforms: new Set(), platformTicket: '' },
  7: { sc: 'ageing_days', sa: false, clients: new Set(), clientIds: new Set(), statuses: new Set(), kams: new Set(), platforms: new Set() },
};

function tktSrc(n){ return n===6?TICKETS_GRN:TICKETS_OD; }

function applyTktF(data, n){
  const s=TST[n];
  return data.filter(r=>{
    if(s.clients.size && !s.clients.has(r.client_name)) return false;
    if(s.clientIds.size && !s.clientIds.has(String(r.client_id))) return false;
    if(n===6 && s.issueTypes.size && !s.issueTypes.has(r.issue_type)) return false;
    if(s.statuses.size && !s.statuses.has(r.status)) return false;
    if(s.kams.size && !s.kams.has(r.kam)) return false;
    if(s.platforms.size && !s.platforms.has(r.platform)) return false;
    if(n===6 && s.platformTicket==='has' && !r.platform_ticket_number) return false;
    if(n===6 && s.platformTicket==='missing' && r.platform_ticket_number) return false;
    return true;
  });
}

function tktStatusPill(s){
  if(s==='DISPUTE') return '<span class="pill p-r">Dispute</span>';
  if(s==='PENDING_VERIFICATION') return '<span class="pill p-a">Pending Verif.</span>';
  if(s==='OPEN') return '<span class="pill p-b">Open</span>';
  return `<span class="pill p-g">${s}</span>`;
}

function tktIssuePill(t){
  const label=TICKET_ISSUE_LABELS[t]||t;
  const c=t==='grn_missing'?'p-r':t==='grn_short'?'p-a':t==='unbooked_invoice'?'p-o':'p-b';
  return `<span class="pill ${c}">${label}</span>`;
}

function activationPill(s){
  const v=(s||'').toString().trim().toLowerCase();
  if(v==='active') return '<span class="pill p-gr">Active</span>';
  if(v==='trial') return '<span class="pill p-a">TRIAL</span>';
  if(v==='drop'||v==='dropped') return '<span class="pill p-g" style="color:#6B7280;">Dropped</span>';
  return `<span class="pill p-g">${s||'–'}</span>`;
}

function fmtAmount(v){
  if(v==null) return '<span class="muted">–</span>';
  const n=Number(v);
  if(!isFinite(n)) return '<span class="muted">–</span>';
  return '₹'+Math.round(n).toLocaleString('en-IN');
}

function renderTicketsTbl(n){
  const s=TST[n];
  const data=applyTktF(tktSrc(n),n);
  const sorted=[...data].sort((a,b)=>{
    let av=a[s.sc], bv=b[s.sc];
    if(typeof av==='string') return s.sa?av.localeCompare(bv):bv.localeCompare(av);
    return s.sa?(av||0)-(bv||0):(bv||0)-(av||0);
  });
  const tbody=root.getElementById('tb'+n);
  if(!sorted.length){
    const cols=n===6?12:11;
    tbody.innerHTML=`<tr><td colspan="${cols}" class="no-rows">No tickets match this filter</td></tr>`;
    return;
  }
  if(n===6){
    tbody.innerHTML=sorted.map(r=>`<tr>
      <td class="fw6">${escHtml(r.client_name)}</td>
      <td><span class="muted" style="font-size:11px;">${r.client_id||'–'}</span></td>
      <td>${activationPill(r.activation_status)}</td>
      <td>${escHtml(r.platform)}</td>
      <td><span class="muted" style="font-size:11px;">${escHtml(r.invoice_number)}</span></td>
      <td><span class="muted" style="font-size:11px;">${r.invoice_date||'–'}</span></td>
      <td><span class="muted" style="font-size:11px;">${escHtml(r.platform_ticket_number||'–')}</span></td>
      <td>${tktIssuePill(r.issue_type)}</td>
      <td>${tktStatusPill(r.status)}</td>
      <td>${fmtAmount(r.invoice_amount)}</td>
      <td>${daysStr(r.ageing_days)}</td>
      <td><span class="ava ${kamC(r.kam)}">${kamI(r.kam)}</span><span class="muted">${escHtml(r.kam)}</span></td>
    </tr>`).join('');
  } else {
    tbody.innerHTML=sorted.map(r=>`<tr>
      <td class="fw6">${escHtml(r.client_name)}</td>
      <td><span class="muted" style="font-size:11px;">${r.client_id||'–'}</span></td>
      <td>${activationPill(r.activation_status)}</td>
      <td>${escHtml(r.platform)}</td>
      <td><span class="muted" style="font-size:11px;">${escHtml(r.invoice_number)}</span></td>
      <td><span class="muted" style="font-size:11px;">${r.invoice_date||'–'}</span></td>
      <td><span class="muted" style="font-size:11px;">${escHtml(r.platform_ticket_number||'–')}</span></td>
      <td>${tktStatusPill(r.status)}</td>
      <td>${fmtAmount(r.invoice_amount)}</td>
      <td>${daysStr(r.ageing_days)}</td>
      <td><span class="ava ${kamC(r.kam)}">${kamI(r.kam)}</span><span class="muted">${escHtml(r.kam)}</span></td>
    </tr>`).join('');
  }
}

function updateTicketsKPI(n){
  const data=applyTktF(tktSrc(n),n);
  const clients=new Set(data.map(r=>r.client_name));
  if(n===6){
    root.getElementById('k6-total').textContent=data.length;
    root.getElementById('k6-clients').textContent=clients.size+' clients';
    const dispute=data.filter(r=>r.status==='DISPUTE');
    const pending=data.filter(r=>r.status==='PENDING_VERIFICATION');
    root.getElementById('k6-dispute').textContent=dispute.length;
    root.getElementById('k6-dispute-c').textContent=new Set(dispute.map(r=>r.client_name)).size+' clients';
    const disputeNoTkt=dispute.filter(r=>!r.platform_ticket_number);
    root.getElementById('k6-dispute-no-tkt').textContent=disputeNoTkt.length;
    root.getElementById('k6-dispute-no-tkt-c').textContent=new Set(disputeNoTkt.map(r=>r.client_name)).size+' clients';
    root.getElementById('k6-pending').textContent=pending.length;
    root.getElementById('k6-pending-c').textContent=new Set(pending.map(r=>r.client_name)).size+' clients';
  } else {
    root.getElementById('k7-total').textContent=data.length;
    root.getElementById('k7-clients').textContent=clients.size+' clients';
    const avgAge=data.length?Math.round(data.reduce((s,r)=>s+r.ageing_days,0)/data.length):0;
    root.getElementById('k7-age').textContent=avgAge;
  }
}

function renderTktFilters(n){
  const data=tktSrc(n);
  const clients=sortClients([...new Set(data.map(r=>r.client_name).filter(Boolean))]);
  const statuses=[...new Set(data.map(r=>r.status).filter(Boolean))].sort();
  const kams=sortClients([...new Set(data.map(r=>r.kam).filter(Boolean))]);
  const platforms=sortPlatforms([...new Set(data.map(r=>r.platform).filter(Boolean))]);
  const clientIds=[...new Set(data.map(r=>String(r.client_id)).filter(Boolean))].sort((a,b)=>Number(a)-Number(b));

  const cip=root.getElementById('fp-'+n+'-clientid');
  if(cip) cip.innerHTML=clientIds.map(id=>`<label class="filter-option"><input type="checkbox" onchange="tktToggle(${n},'clientIds','${escHtml(id)}',this.checked)"><span>${escHtml(id)}</span></label>`).join('');

  const pp=root.getElementById('fp-'+n+'-platform');
  if(pp) pp.innerHTML=platforms.map(p=>`<label class="filter-option"><input type="checkbox" onchange="tktToggle(${n},'platforms','${escHtml(p)}',this.checked)"><span>${escHtml(p)}</span></label>`).join('');

  const cp=root.getElementById('fp-'+n+'-client');
  if(cp){
    cp.innerHTML=`<input class="client-search" id="tkt-fs${n}" type="search" placeholder="Search client..." oninput="tktFilterClients(${n},this.value)" onclick="event.stopPropagation()">
      <button type="button" class="filter-option client-option" onclick="tktSetClients(${n},null)">All clients</button>`+
      clients.map(c=>`<label class="filter-option client-option" data-client="${escHtml(c)}"><input type="checkbox" onchange="tktToggleClient(${n},'${escHtml(c)}',this.checked)"><span>${escHtml(c)}</span></label>`).join('');
  }

  const sp=root.getElementById('fp-'+n+'-status');
  if(sp) sp.innerHTML=statuses.map(s=>`<label class="filter-option"><input type="checkbox" onchange="tktToggle(${n},'statuses','${escHtml(s)}',this.checked)"><span>${escHtml(s)}</span></label>`).join('');

  const kp=root.getElementById('fp-'+n+'-kam');
  if(kp) kp.innerHTML=kams.map(k=>`<label class="filter-option"><input type="checkbox" onchange="tktToggle(${n},'kams','${escHtml(k)}',this.checked)"><span>${escHtml(k)}</span></label>`).join('');

  if(n===6){
    const ip=root.getElementById('fp-6-issuetype');
    const issueTypes=[...new Set(data.map(r=>r.issue_type).filter(Boolean))].sort();
    if(ip) ip.innerHTML=issueTypes.map(t=>`<label class="filter-option"><input type="checkbox" onchange="tktToggle(6,'issueTypes','${escHtml(t)}',this.checked)"><span>${escHtml(TICKET_ISSUE_LABELS[t]||t)}</span></label>`).join('');
  }

  syncTktBtns(n);
}

function syncTktBtns(n){
  const s=TST[n];
  const clientBtn=root.getElementById('fm-'+n+'-client');
  if(clientBtn) clientBtn.textContent=s.clients.size===1?[...s.clients][0]:s.clients.size>1?s.clients.size+' clients':'All clients';
  const clientIdBtn=root.getElementById('fm-'+n+'-clientid');
  if(clientIdBtn){clientIdBtn.textContent=s.clientIds.size?s.clientIds.size===1?[...s.clientIds][0]:s.clientIds.size+' IDs':'Client ID';clientIdBtn.classList.toggle('on',s.clientIds.size>0);}
  const platformBtn=root.getElementById('fm-'+n+'-platform');
  if(platformBtn){platformBtn.textContent=s.platforms.size?s.platforms.size===1?[...s.platforms][0]:s.platforms.size+' platforms':'Platform';platformBtn.classList.toggle('on',s.platforms.size>0);}
  const statusBtn=root.getElementById('fm-'+n+'-status');
  if(statusBtn) statusBtn.textContent=s.statuses.size?s.statuses.size+' statuses':'Status';
  const kamBtn=root.getElementById('fm-'+n+'-kam');
  if(kamBtn) kamBtn.textContent=s.kams.size?s.kams.size===1?[...s.kams][0]:s.kams.size+' KAMs':'KAM';
  if(n===6){
    const itBtn=root.getElementById('fm-6-issuetype');
    if(itBtn) itBtn.textContent=s.issueTypes.size?s.issueTypes.size+' types':'Issue Type';
    const ptBtn=root.getElementById('fm-6-platformticket');
    if(ptBtn){
      ptBtn.textContent=s.platformTicket==='has'?'Has Ticket #':s.platformTicket==='missing'?'No Ticket #':'Ticket #';
      ptBtn.classList.toggle('on',!!s.platformTicket);
    }
  }
}

function setTktPlatformTicket(n,val){
  TST[n].platformTicket=val;
  syncTktBtns(n);
  refreshTickets(n);
}

function tktToggle(n,field,val,checked){
  if(checked) TST[n][field].add(val);
  else TST[n][field].delete(val);
  syncTktBtns(n);
  refreshTickets(n);
}

function tktToggleClient(n,val,checked){
  if(checked) TST[n].clients.add(val);
  else TST[n].clients.delete(val);
  syncTktBtns(n);
  refreshTickets(n);
}

function tktSetClients(n,val){
  TST[n].clients.clear();
  syncTktBtns(n);
  refreshTickets(n);
}

function tktFilterClients(n,query){
  const q=(query||'').trim().toLowerCase();
  const panel=root.getElementById('fp-'+n+'-client');
  if(!panel)return;
  panel.querySelectorAll('.client-option').forEach(el=>{
    const name=(el.dataset.client||'').toLowerCase();
    el.style.display=!q||!name||name.includes(q)?'flex':'none';
  });
}

function toggleTktMenu(n,group,event){
  if(event) event.stopPropagation();
  const panel=root.getElementById('fp-'+n+'-'+group);
  if(!panel)return;
  const menu=panel.closest('.filter-menu');
  const wasOpen=menu.classList.contains('open');
  closeFilterMenus();
  menu.classList.toggle('open',!wasOpen);
  if(!wasOpen&&group==='client'){
    const search=root.getElementById('tkt-fs'+n);
    if(search){search.value='';tktFilterClients(n,'');setTimeout(()=>search.focus(),0);}
  }
}

function tktSrt(n,col){
  const s=TST[n];
  if(s.sc===col) s.sa=!s.sa; else{s.sc=col;s.sa=true;}
  renderTicketsTbl(n);
}

function refreshTickets(n){
  updateTicketsKPI(n);
  renderTicketsTbl(n);
}

// ── Credential Verification Pending ──────────────────────────────────────────
function credStatusPill(status){
  if(status==='Under Verification') return '<span class="pill p-a">Under Verification</span>';
  if(status==='Upload Queued') return '<span class="pill p-b">Upload Queued</span>';
  return `<span class="pill p-g">${escHtml(status||'–')}</span>`;
}

function setCredFilter(f, el){
  CRED_FILTER=f;
  root.querySelectorAll('#fb8 .fp').forEach(p=>p.classList.toggle('on',p.dataset.f8===f));
  renderPendingCreds();
}

function renderPendingCreds(){
  const tbody=root.getElementById('tb8');
  if(!tbody)return;
  const all=PENDING_CREDS;
  const uv=all.filter(r=>r.status==='Under Verification');
  const uq=all.filter(r=>r.status==='Upload Queued');
  root.getElementById('k8-uv').textContent=uv.length;
  root.getElementById('k8-uv-c').textContent=new Set(uv.map(r=>r.clientId)).size+' clients';
  root.getElementById('k8-uq').textContent=uq.length;
  root.getElementById('k8-uq-c').textContent=new Set(uq.map(r=>r.clientId)).size+' clients';
  const data=CRED_FILTER==='uv'?uv:CRED_FILTER==='uq'?uq:all;
  if(!all.length){
    tbody.innerHTML='<tr><td colspan="5" class="no-rows">None pending</td></tr>';
    return;
  }
  if(!data.length){
    tbody.innerHTML='<tr><td colspan="5" class="no-rows">No records match this filter</td></tr>';
    return;
  }
  tbody.innerHTML=data.map(r=>`<tr>
    <td>${credStatusPill(r.status)}</td>
    <td class="fw6">${escHtml(r.clientName)}</td>
    <td><span class="muted" style="font-size:11px;">${r.clientId||'–'}</span></td>
    <td><span class="muted" style="font-size:11px;">${escHtml(r.gstNumber)}</span></td>
    <td><span class="muted" style="font-size:11px;">${escHtml(r.passwordUpdatedAt||'–')}</span></td>
  </tr>`).join('');
}

// ── Unmapped Vendors (Shared Login) ─────────────────────────────────────────
const VENDORS_API_URL = BASE_SERVER_URL + '/UnmappedVendors';
let VEN_CURRENT = [], VEN_RESOLVED = [];
const VST = { sc:'days', sa:false, platform:'', q:'' };

function venDays(iso){
  if(!iso) return 0;
  const d=new Date(iso);
  if(Number.isNaN(d.getTime())) return 0;
  return Math.max(0, Math.floor((Date.now()-d.getTime())/MS_PER_DAY));
}

function fmtVenDate(iso){
  if(!iso) return '–';
  const d=new Date(iso);
  if(Number.isNaN(d.getTime())) return '–';
  return d.toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'});
}

function venMatch(r){
  if(VST.platform && (r.platform||'')!==VST.platform) return false;
  if(VST.q){
    const q=VST.q.toLowerCase();
    const hay=((r.vendor_name||'')+' '+(r.client_name||'')).toLowerCase();
    if(!hay.includes(q)) return false;
  }
  return true;
}

function renderVendorFilters(){
  const platforms=sortPlatforms([...new Set([...VEN_CURRENT,...VEN_RESOLVED].map(r=>r.platform).filter(Boolean))]);
  const sel=root.getElementById('ven-platform');
  if(!sel) return;
  const cur=VST.platform;
  sel.innerHTML='<option value="">All platforms</option>'+platforms.map(p=>`<option value="${escHtml(p)}">${escHtml(p)}</option>`).join('');
  sel.value=cur;
}

function updateVendorKPI(){
  const cur=VEN_CURRENT.filter(venMatch);
  const res=VEN_RESOLVED.filter(venMatch);
  root.getElementById('k9-current').textContent=cur.length;
  root.getElementById('k9-current-p').textContent=new Set(cur.map(r=>r.platform).filter(Boolean)).size+' platforms';
  root.getElementById('k9-resolved').textContent=res.length;
  root.getElementById('k9-resolved-c').textContent=new Set(res.map(r=>r.client_name).filter(Boolean)).size+' clients';
  const oldest=cur.reduce((m,r)=>Math.max(m,venDays(r.first_occurred_at)),0);
  root.getElementById('k9-oldest').textContent=cur.length?oldest:'–';
}

function renderVendorCurrent(){
  const data=VEN_CURRENT.filter(venMatch).map(r=>({...r,days:venDays(r.first_occurred_at)}));
  const s=VST;
  data.sort((a,b)=>{
    let av=a[s.sc], bv=b[s.sc];
    if(s.sc==='first_occurred_at'){av=a.days;bv=b.days;}
    if(typeof av==='string') return s.sa?av.localeCompare(bv):bv.localeCompare(av);
    return s.sa?(av||0)-(bv||0):(bv||0)-(av||0);
  });
  const tb=root.getElementById('tb9');
  if(!tb) return;
  if(!data.length){ tb.innerHTML='<tr><td colspan="5" class="no-rows">No unmapped vendors match this filter</td></tr>'; return; }
  tb.innerHTML=data.map(r=>`<tr>
    <td class="fw6">${escHtml(r.vendor_name)}</td>
    <td>${escHtml(r.platform||'–')}</td>
    <td><span class="muted">${fmtVenDate(r.first_occurred_at)}</span></td>
    <td>${daysStr(r.days)}</td>
    <td><span class="muted">${r.trigger_count||0}</span></td>
  </tr>`).join('');
}

function renderVendorResolved(){
  const data=VEN_RESOLVED.filter(venMatch).slice().sort((a,b)=>new Date(b.resolved_at)-new Date(a.resolved_at));
  const tbl=root.getElementById('res-tbl-9');
  const cnt=root.getElementById('res-cnt-9');
  if(!tbl) return;
  if(cnt) cnt.textContent='('+data.length+')';
  const hdr=`<thead><tr><th>Vendor</th><th>Platform</th><th>Mapped to client</th><th>Client ID</th><th>Resolved</th></tr></thead>`;
  if(!data.length){ tbl.innerHTML=hdr+'<tbody><tr><td class="no-rows" colspan="5">No recently mapped vendors</td></tr></tbody>'; return; }
  tbl.innerHTML=hdr+'<tbody>'+data.map(r=>`<tr>
    <td class="fw6">${escHtml(r.vendor_name)}</td>
    <td>${escHtml(r.platform||'–')}</td>
    <td>${escHtml(r.client_name||'–')}</td>
    <td><span class="muted">${r.client_id!=null?escHtml(r.client_id):'–'}</span></td>
    <td><span class="pill p-gr">✓ Mapped</span> <span class="muted" style="font-size:10px;">${fmtVenDate(r.resolved_at)}</span></td>
  </tr>`).join('')+'</tbody>';
}

function venSrt(col){
  if(VST.sc===col) VST.sa=!VST.sa; else{VST.sc=col;VST.sa=true;}
  renderVendorCurrent();
}

function refreshVendors(){
  const search=root.getElementById('ven-search');
  const platform=root.getElementById('ven-platform');
  VST.q=search?search.value:'';
  VST.platform=platform?platform.value:'';
  updateVendorKPI();
  renderVendorCurrent();
  renderVendorResolved();
}

async function fetchVendors(){
  try{
    const res=await fetch(VENDORS_API_URL,API_REQUEST_OPTIONS);
    if(!res.ok) throw new Error('HTTP '+res.status);
    const raw=await res.json();
    VEN_CURRENT=Array.isArray(raw?.current)?raw.current:[];
    VEN_RESOLVED=Array.isArray(raw?.resolved)?raw.resolved:[];
  }catch(e){
    // Degrade to empty — tables render a "no data" state instead of crashing.
    console.warn('Unmapped vendors fetch failed:',e);
    VEN_CURRENT=[];VEN_RESOLVED=[];
  }
  try{ renderVendorFilters(); refreshVendors(); }
  catch(e){console.warn('Unmapped vendors render failed:',e);}
}

// ── API fetch & init ─────────────────────────────────────────────────────────
// Every API call is isolated: a failure degrades only its own section to an
// empty "no data" state — it never crashes the dashboard or blocks the others.
async function fetchAlerts(){
  try{
    const res=await fetch(API_URL,API_REQUEST_OPTIONS);
    if(!res.ok)throw new Error('HTTP '+res.status);
    const raw=await res.json();
    const rawAlerts=Array.isArray(raw)?raw:(raw?.alerts||[]);
    const all=rawAlerts.map(transformRecord);
    const sortFn=(a,b)=>(SEV[a.sev]??3)-(SEV[b.sev]??3)||b.days-a.days||a.client.localeCompare(b.client);
    RF     =all.filter(r=>r.category==='Red Flag'&&r.sev!=='resolved').sort(sortFn);
    OPS    =all.filter(r=>r.category==='Operational Error'&&r.sev!=='resolved').sort(sortFn);
    RF_RES =all.filter(r=>r.category==='Red Flag'&&r.sev==='resolved').sort((a,b)=>b.days-a.days);
    OPS_RES=all.filter(r=>r.category==='Operational Error'&&r.sev==='resolved').sort((a,b)=>b.days-a.days);
    ALL=[...RF,...OPS];
  }catch(e){
    console.warn('Alerts fetch failed:',e);
    RF=[];OPS=[];ALL=[];RF_RES=[];OPS_RES=[];
  }
  try{
    renderDynamicFilters();
    [1,2,3,4,5].forEach(syncPills);
    renderTbl(1,false); updateKPI(1); renderResolved(1);
    buildRFAnalysis();
    renderTbl(3,false); updateKPI(3); renderResolved(3);
    buildOpsAnalysis();
    renderTbl(5,true); renderResolved(5);
  }catch(e){console.warn('Alerts render failed:',e);}
}

async function fetchCreds(){
  try{
    const credsRes=await fetch(PENDING_CREDS_URL,API_REQUEST_OPTIONS);
    if(credsRes.ok){
      const credsRaw=await credsRes.json();
      PENDING_CREDS=(credsRaw.data||[]);
    }
  }catch(ce){
    console.warn('Pending creds fetch failed:',ce);
    PENDING_CREDS=[];
  }
  try{ renderPendingCreds(); }catch(e){console.warn('Creds render failed:',e);}
}

async function fetchTickets(){
  try{
    const tktRes=await fetch(TICKETS_API_URL,API_REQUEST_OPTIONS);
    if(!tktRes.ok)throw new Error('HTTP '+tktRes.status);
    const tktRaw=await tktRes.json();
    const allTickets=(tktRaw.tickets||[]).map(r=>({...r,kam:camNameFromRecord(r)}));
    TICKETS_GRN=allTickets.filter(r=>r.issue_type!=='payment_overdue');
    TICKETS_OD=allTickets.filter(r=>r.issue_type==='payment_overdue');
  }catch(te){
    console.warn('Tickets fetch failed:',te);
    TICKETS_GRN=[];TICKETS_OD=[];
  }
  // Tab 6 (GRN) and 7 (payment overdue, currently disabled) render independently.
  try{ renderTktFilters(6); refreshTickets(6); }catch(e){console.warn('GRN tickets render failed:',e);}
  try{ renderTktFilters(7); refreshTickets(7); }catch(e){/* payment-overdue tab disabled */}
}

async function fetchAndInit(){
  root.getElementById('ems-loading').style.display='flex';
  root.getElementById('ems-err').style.display='none';

  // Update date to today
  const dateStr=new Date().toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
  root.querySelectorAll('.ems-date').forEach(el=>el.textContent=dateStr);

  // Run all three sections; each swallows its own errors so one failure
  // can't take down the rest.
  await Promise.allSettled([fetchAlerts(), fetchTickets(), fetchVendors(), fetchCreds()]);

  root.getElementById('ems-loading').style.display='none';
}

// Default KAM filter seeding (from the React auth context) — pre-selects the
// logged-in KAM's own name in every section's filter. Still fully editable/
// clearable by the user; this only sets the starting selection.
if (defaultKam) {
  Object.values(ST).forEach(s => s.filters.add(camFilterValue(defaultKam)));
  Object.values(TST).forEach(s => s.kams.add(defaultKam));
}


  Object.assign(window, { showSec, setF, setActivationFilter, setDropdownFilter, setClientFilter, filterClientOptions, toggleFilterMenu, srt, toggleRes, toggleTktMenu, setTktPlatformTicket, tktSrt, tktToggle, tktToggleClient, tktSetClients, tktFilterClients, setCredFilter, venSrt, refreshVendors, fetchAndInit });
  fetchAndInit();
  // Connection details, so add-on tabs (GST Upload Tracker) reuse EMS's config.
  return { baseUrl: BASE_SERVER_URL, requestOptions: API_REQUEST_OPTIONS };
}
